<template>
  <div :class="['metric-card', variant ? 'variant-' + variant : '']">
    <div class="metric-label">{{ label }}</div>
    <div class="metric-value"><slot>{{ value }}</slot></div>
  </div>
</template>

/* eslint-env vue/setup-compiler-macros */
/* eslint-disable no-undef */
<script setup>
defineProps({
  label: { type: String, default: '' },
  value: { type: [String, Number], default: '' },
  variant: { type: String, default: '' }
});
</script>

<style scoped>
.metric-card{display:flex;flex-direction:column;gap:6px;padding:10px;background:var(--background-color);border:1px solid rgba(var(--text-color-secondary-rgb),0.06);border-radius:6px;min-width:150px;align-items:flex-start}
.metric-label{color:var(--text-color-secondary);font-size:12px}
.metric-value{font-size:18px;color:var(--text-color-primary);font-weight:700}
.metric-card.variant-financial{background:var(--background-color-secondary)}
</style>
